module.exports = __webpack_public_path__ + "img/shortcut_white.fa0ab34a.svg";